import React from "react";
import { Link } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

export const LinkItemNode = (props) => {
  return (
    <Link href={props.location} color="teal.500" isExternal>
      {props.description} <ExternalLinkIcon />
    </Link>
  );
};
